import '../scss/index.scss';
import App from './App';

//import { isLoadedImages } from "./utils/isLoadedImages";

const app = new App();
app.render();

// const preloadImages = document.querySelectorAll('[data-js-preload-images]')
// isLoadedImages(preloadImages).then(() => {

// })
